/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { fixedT, translationKeys } from "./../Internationalisierung/i18nDomainDrivenDesign";
import CloudTypenName from "./CloudTypenName";

export default interface CloudTyp {
    name: string;
    ermittleBezeichnung: () => string;
    ermittleUrl: (id: string) => string;
    urlInNeuemTabOeffnen: boolean;
    urlIstDateiDownload: boolean;
}

class CloudTypen {
    private static readonly cloudTypen: { [key: string]: CloudTyp } = {
        [CloudTypenName.SEMINARE_SEMINAREKATEGORIE_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINAREKATEGORIE_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.kategorie),
            ermittleUrl: (id) => `/kategorie/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINAR_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINAR_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltung),
            ermittleUrl: (id) => `/seminar/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINARREIHE_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINARREIHE_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungsreihe),
            ermittleUrl: (id) => `/seminarreihe/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINARTEXTE_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINARTEXTE_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungstexte),
            ermittleUrl: (id) => "",
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINAR_TEAMS_EINSTELLUNGEN_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINAR_TEAMS_EINSTELLUNGEN_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungsTeamsEinstellungen),
            ermittleUrl: (seminarId) => `/seminar/${seminarId}/teams`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINAR_ZOOM_EINSTELLUNGEN_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINAR_TEAMS_EINSTELLUNGEN_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungsZoomEinstellungen),
            ermittleUrl: (seminarId) => `/seminar/${seminarId}/zoom`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.SEMINARE_SEMINAREVALUATION_NAME]: {
            name: CloudTypenName.SEMINARE_SEMINAREVALUATION_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungsEvaluation),
            ermittleUrl: (seminarId) => `/seminar/${seminarId}/evaluation`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_TEILNAHME_NAME]: {
            name: CloudTypenName.TEILNAHMEN_TEILNAHME_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.teilnahme),
            ermittleUrl: (id) => `/teilnahme/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_ADRESSE_NAME]: {
            name: CloudTypenName.TEILNAHMEN_ADRESSE_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.teilnahmenadresse),
            ermittleUrl: (id) => "",
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_LEISTUNG_NAME]: {
            name: CloudTypenName.TEILNAHMEN_LEISTUNG_NAME,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.teilnahmenleistung),
            ermittleUrl: (id) => "",
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.BELEGE_BELEG]: {
            name: CloudTypenName.BELEGE_BELEG,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.beleg),
            ermittleUrl: (id) => `/beleg/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.BELEGE_BELEGPOSITION]: {
            name: CloudTypenName.BELEGE_BELEGPOSITION,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.belegposition),
            ermittleUrl: (id) => `/belegposition/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.BELEGE_FIBUEXPORT]: {
            name: CloudTypenName.BELEGE_FIBUEXPORT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.fibuExport),
            ermittleUrl: (id) => `/fibuExport/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_TEILNAHMELISTENPOSITION]: {
            name: CloudTypenName.TEILNAHMEN_TEILNAHMELISTENPOSITION,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.teilnahme),
            ermittleUrl: (id) => `/teilnahmelistenposition/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_TEILNAHMELISTE]: {
            name: CloudTypenName.TEILNAHMEN_TEILNAHMELISTE,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltung),
            ermittleUrl: (id) => `/teilnahmeliste/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_BESTELLUNG]: {
            name: CloudTypenName.TEILNAHMEN_BESTELLUNG,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.bestellung),
            ermittleUrl: (id) => `/bestellungen`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_BESTELLPOSITION]: {
            name: CloudTypenName.TEILNAHMEN_BESTELLPOSITION,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.bestellposition),
            ermittleUrl: (id) => `/bestellposition/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_BESTELLTERARTIKEL]: {
            name: CloudTypenName.TEILNAHMEN_BESTELLTERARTIKEL,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.bestellterArtikel),
            ermittleUrl: (id) => `/bestellterArtikel/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.ADRESSEN_ADRESSENKATEGORIE]: {
            name: CloudTypenName.ADRESSEN_ADRESSENKATEGORIE,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.kategorie),
            ermittleUrl: (id) => `/adresskategorien/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.ADRESSEN_ADRESSE]: {
            name: CloudTypenName.ADRESSEN_ADRESSE,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.adresse),
            ermittleUrl: (id) => `/adresse/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.DOKUMENTE_TEILNAHMEZERTIFIKAT]: {
            name: CloudTypenName.DOKUMENTE_TEILNAHMEZERTIFIKAT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.teilnahmeZertifikat),
            ermittleUrl: (id) => `/teilnahmeZertifikat/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.DOKUMENTE_SEMINARDOZIERENDZERTIFIKAT]: {
            name: CloudTypenName.DOKUMENTE_SEMINARDOZIERENDZERTIFIKAT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.veranstaltungsDozierendZertifikat),
            ermittleUrl: (id) => `/seminarDozierendZertifikat/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.PAYMENTS_ANFECHTUNG]: {
            name: CloudTypenName.PAYMENTS_ANFECHTUNG,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.anfechtung),
            ermittleUrl: (id) => `/stripeAnfechtung/${id}`,
            urlInNeuemTabOeffnen: true,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.RESSOURCEN_RESSOURCE]: {
            name: CloudTypenName.RESSOURCEN_RESSOURCE,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.ressource),
            ermittleUrl: (id) => `/ressource/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.RESSOURCEN_KATEGORIE]: {
            name: CloudTypenName.RESSOURCEN_KATEGORIE,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.ressourceKategorie),
            ermittleUrl: (id) => `/ressourcenkategorie/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.RESSOURCEN_BELEGUNG]: {
            name: CloudTypenName.RESSOURCEN_BELEGUNG,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.belegung),
            ermittleUrl: (id) => `/belegung/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.DOKUMENTE_EMAIL]: {
            name: CloudTypenName.DOKUMENTE_EMAIL,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.eMail),
            ermittleUrl: (id) => "/postausgang",
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.EXPORTE_CSVEXPORT]: {
            name: CloudTypenName.EXPORTE_CSVEXPORT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.csvExport),
            ermittleUrl: csvExportId => `csvexport?csvExportId=${csvExportId}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: true,
        },
        [CloudTypenName.MAHLZEITEN_MAHLZEIT]: {
            name: CloudTypenName.MAHLZEITEN_MAHLZEIT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.mahlzeit),
            ermittleUrl: (id) => `/mahlzeit/${id}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.TEILNAHMEN_REGEL]: {
            name: CloudTypenName.TEILNAHMEN_REGEL,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.regel),
            ermittleUrl: regelId => `/regel/${regelId}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
        [CloudTypenName.IMPORTE_CSVIMPORT]: {
            name: CloudTypenName.IMPORTE_CSVIMPORT,
            ermittleBezeichnung: () => fixedT(translationKeys.cloudTypen.csvImport),
            ermittleUrl: csvImportId => `/import/${csvImportId}`,
            urlInNeuemTabOeffnen: false,
            urlIstDateiDownload: false,
        },
    };

    public ermittle(typname: string): CloudTyp {
        const typ = CloudTypen.cloudTypen[typname];
        if (typ === undefined && process.env.NODE_ENV === "development" && !typname.startsWith("Mandanten_")) {
            window.alert(`Unbekannter CloudTyp '${typname}'. Ergänze '${typname}' in CloudTypen.ts.`);
        }

        return typ;
    }
}

export const cloudTypen: CloudTypen = new CloudTypen();